import { render } from "./professione.vue?vue&type=template&id=84f6c97e"
const script = {}

import exportComponent from "/home/bovero/Downloads/sito_vue3/vueboot5/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__